import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function saveCountry(app, dataToSave) {
  const { user = {}, data } = dataToSave;

  const countryData = {
    doc_type: DocType.COUNTRY,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    code: util.toStringText(data.code),
    currency_id: data.currency_id,
    system_defined: util.toBoolean(data.system_defined)
  };

  return common.saveDoc(app, {
    source: data,
    doc: countryData,
    user,
  });
}

export function fetchCountryDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'country/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function deleteCountry(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.COUNTRY
  });
}

export function fetchCountryById(app, params) {
  const { id } = params;
  const docType = DocType.COUNTRY;
  return common.getDoc(app, { id, docType });
}
